/* src/app/do-planning/do-planning.component.css */
:host ::ng-deep .nacogr {
  background-color: #e0e0e0 !important;
  font-family: "Roboto" !important;
}
form {
  width: 1280px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 5px;
  cursor: default;
}
.wrapper3 {
  display: grid;
  grid-template-columns: 35% 35% 35%;
}
.wrapper2 {
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 10px;
}
.wrapper2 div {
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 5px;
  margin: 5px;
  background-color: #e0e0e0;
}
form button {
  background-color: #a8a8a8 !important;
  color: white;
  border: none;
  width: 250px;
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  transition: 0.2s ease;
}
form button:hover {
  background-color: #676767 !important;
}
.button:active {
  transform: scale(0.96);
}
:host ::ng-deep .ui-button.ui-widget.ui-state-default.ui-button-text-only.ui-state-active {
  background-color: #e0e0e0 !important;
}
.container,
.inputcontainer {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.inputcontainer {
  width: 100%;
  padding-left: 0px;
  height: 35px;
}
.inputcontainer input {
  width: 100px;
  float: right;
}
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 5px;
}
.container:hover input ~ .checkmark {
  background-color: #ccc;
}
.container input:checked ~ .checkmark {
  background-color: #ffffff;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.container input:checked ~ .checkmark:after {
  display: block;
}
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid #8e8e8e;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
body .p-select-panel .p-select-item:not(.p-disabled):hover,
body .p-dropdown-panel .p-dropdown-item:not(.p-disabled):hover {
  background: #e3e3e3 !important;
  color: #000 !important;
}
body .p-select-panel .p-select-item.p-focus,
body .p-dropdown-panel .p-dropdown-item.p-focus,
body .p-select-panel .p-select-item:focus,
body .p-dropdown-panel .p-dropdown-item:focus {
  background: #e3e3e3 !important;
  color: #000 !important;
  box-shadow: none !important;
  outline: none !important;
}
body .p-select-panel .p-select-item.p-highlight,
body .p-dropdown-panel .p-dropdown-item.p-highlight,
body .p-select-panel [aria-selected=true],
body .p-dropdown-panel [aria-selected=true] {
  background: #e6e6e6 !important;
  color: #333 !important;
}
:root {
  --p-highlight-bg: #e6e6e6 !important;
  --p-highlight-color: #333 !important;
  --p-list-option-focus-background: #e3e3e3 !important;
  --p-list-option-hover-background: #e3e3e3 !important;
  --p-list-option-focus-color: #000 !important;
  --p-primary-100: #e6e6e6 !important;
  --p-primary-color: #9e9e9e !important;
}
/*# sourceMappingURL=do-planning.component.css.map */
